import { useMemo as o, useState as r, useEffect as n } from "../external/preact/hooks/dist/hooks.module.js";
const d = (t) => {
  const e = o(() => window.matchMedia(t), [t]), [c, s] = r(e.matches);
  return n(() => {
    const a = (h) => s(h.matches);
    return e.addEventListener("change", a), () => e.removeEventListener("change", a);
  }, [e]), n(() => {
    s(e.matches);
  }, [e]), c;
};
export {
  d as default,
  d as useMediaQuery
};
